import React, { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import MobileMenu from '../MobileMenu/MobileMenu'
import Logo from '../../images/FFwedding.PNG'
import { totalPrice } from "../../utils";
import { connect } from "react-redux";
import { removeFromCart } from "../../store/actions/action";
import { SiWhatsapp } from "react-icons/si";


import { TbBrandPinterest } from "react-icons/tb";

const Header = (props) => {
    const [menuActive, setMenuState] = useState(false);
    const [cartActive, setcartState] = useState(false);

    const SubmitHandler = (e) => {
        e.preventDefault()
    }

    const ClickHandler = () => {
        // window.scrollTo(110, 110);
    }

    const { carts } = props;

    return (
        <>

            <header id="header" className={props.topbarNone}>
                <div className={`wpo-site-header wpo-header-style-1 ${props.hclass}`}>
                    <nav className="navigation navbar navbar-expand-lg">
                        <div className="container-fluid">
                            <div className="row align-items-center justify-content-between ">
                                <div className="col-md-3 col-3 d-lg-none d-flex justify-content-end order-1">
                                    <div className="mobail-menu">
                                        <MobileMenu />
                                    </div>
                                </div>

                                <div className="col-lg-2 col-md-2 col-4 order-0">
                                    <div className='brand-logo'><NavLink className="navbar-brand" to="/"><img
                                        src={Logo}
                                        className="w-100"
                                        alt="logo"
                                        fetchpriority="high"

                                    /></NavLink></div>
                                </div>

                                {/* <div className="col-md-6 col-6 d-lg-none dl-block">
                                <div className="navbar-header">
                                    <NavLink className="navbar-brand" to="/"><img src={Logo}
                                            alt="" /></NavLink>
                                </div>
                            </div> */}
                                <div className="col-lg-8 col-md-1 col-1">
                                    <div id="navbar" className="collapse navbar-collapse navigation-holder">
                                        <button className="menu-close"><i className="ti-close"></i></button>
                                        <ul className="nav navbar-nav mb-2 mb-lg-0">
                                            <li className="menu-item-has-children">
                                                <NavLink to="/">Home</NavLink>

                                            </li>
                                            <li className="menu-item-has-children">
                                                <NavLink to="/about">About</NavLink>
                                            </li>
                                            <li className="menu-item-has-children">
                                                <NavLink to="/portfolio-photo">Photography
                                                </NavLink>
                                            </li>
                                            <li className="menu-item-has-children">
                                                <NavLink to="/Testimonial">Testimonial
                                                </NavLink>
                                            </li>
                                            <li className="menu-item-has-children">
                                                <NavLink to="/hotc-films">Films</NavLink>

                                            </li>
                                            <li className="menu-item-has-children"><NavLink onClick={ClickHandler} to="/inquiry1">Inquiry</NavLink></li>
                                            <li className="menu-item-has-children">
                                                <Link to={''}>More
                                                </Link>
                                                <ul className="sub-menu">
                                                    <li><NavLink onClick={ClickHandler} to="/careers">CAREERS</NavLink></li>
                                                    <li><NavLink onClick={ClickHandler} to="/travel">TRAVEL</NavLink></li>
                                                    <li><NavLink onClick={ClickHandler} to="/backyard">BACKYARD</NavLink></li>
                                                    <li><NavLink onClick={ClickHandler} to="/editorial">EDITORIAL</NavLink></li>

                                                </ul>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-6 col-6 d-lg-block d-none">
                                    <div className="social-info">
                                        <ul className="mb-0">
                                            <li><a href="https://www.facebook.com/FFweddingz"><i className="fi flaticon-facebook-app-symbol"></i></a></li>
                                            <li><a href="https://api.whatsapp.com/send/?phone=919925876341&text&type=phone_number&app_absent=0">  <SiWhatsapp style={{ marginBottom: "3px" }} className='whatsappIcon' /></a></li>
                                            <li><a href="https://www.instagram.com/ff_weddingz/"><i className="fi flaticon-instagram-1"></i></a></li>
                                            <li><a href="https://pin.it/52uQbnEZg"><i className="fi flaticon-pinterest"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                                {/* <div className="col-lg-2 col-md-2 col-2">
                                <div className="header-right">
                                    <div className="header-search-form-wrapper">
                                        <div className="cart-search-contact">
                                            <button onClick={() => setMenuState(!menuActive)} className="search-toggle-btn"><i
                                                className={`ti-search ${menuActive ? "ti-close" : "ti-search"}`}></i></button>
                                            <div className={`header-search-form ${menuActive ? "header-search-content-toggle" : ""}`}>
                                                <form onSubmit={SubmitHandler}>
                                                    <div>
                                                        <input type="text" className="form-control"
                                                            placeholder="Search here..." />
                                                        <button type="submit"><i
                                                            className="fi ti-search"></i></button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                         
                                </div>
                            </div> */}
                            </div>
                        </div>
                    </nav>
                </div>
            </header>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        carts: state.cartList.cart,
    };
};
export default connect(mapStateToProps, { removeFromCart })(Header);